// src/components/layout/WhatsApp/WhatsApp.jsx
import React, { useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./whatsApp.css";
import Loader from "../../elements/Loader/Loader";
import useStore from "../../../useStore";
import { useToast } from "../../../Contexts/Toast/toast.provider";

const WhatsApp = () => {
  const whats = useStore(state => state.whats);
  const loading = useStore(state => state.loading);
  const error = useStore(state => state.error);
  const fetchWhats = useStore(state => state.fetchWhats);
  const showToast = useToast();

  // 1) Cargar datos al montar
  useEffect(() => {
    fetchWhats();
  }, [fetchWhats]);

  // 2) Mostrar toast si hay error
  useEffect(() => {
    if (error) {
      showToast("error", `❌ Error al cargar WhatsApp: ${error}`);
    }
  }, [error, showToast]);

  // 3) Loader o fallback si no hay datos
  if (loading) return <Loader />;
  if (!Array.isArray(whats) || whats.length === 0) return null;

  const { numero: phoneNumber, mensaje: message } = whats[0];

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
    >
      <FaWhatsapp size={40} />
    </a>
  );
};

export default WhatsApp;
